import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { size, color } from '../styles/helpers/variables';
import { fontFamilyHeading, dynamicFontSize } from '../styles/helpers/mixins';

const ReadMoreAbout = props => {
  const { pageTitle, pageUrl, pos } = props;
  return (
    <ReadMoreContainer pos={pos}>
      <ReadMoreTag>Läs mer om</ReadMoreTag>
      <ReadMoreLink to={pageUrl}>{pageTitle}</ReadMoreLink>
    </ReadMoreContainer>
  );
};

const ReadMoreContainer = styled.div`
  padding-top: 30px;
  padding-bottom: 50px;
  padding-right: 0;
  padding-left: 0;
  @media screen and (min-width: ${size.medium}px) {
    padding-right: 90px;
  }
  ${props =>
    props.pos === 'right' &&
    css`
      padding-right: 0;
      padding-left: 0;
      @media screen and (min-width: ${size.medium}px) {
        padding-left: 90px;
        padding-right: 0;
      }
    `};
`;

const ReadMoreTag = styled.span`
  ${dynamicFontSize(10, 13, size.small, size.medium)};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: ${color.black};
`;

const ReadMoreLink = styled(Link)`
  ${dynamicFontSize(24, 32, size.small, size.medium)};
  ${fontFamilyHeading};
  display: block;
  text-decoration: none;
  line-height: 1.25;
  color: #000000;
  margin-top: 20px;
`;

ReadMoreAbout.defaultProps = {
  pageTitle: '',
  pageUrl: '',
  pos: ''
};

ReadMoreAbout.propTypes = {
  pageTitle: PropTypes.string,
  pageUrl: PropTypes.string,
  pos: PropTypes.string
};

export default ReadMoreAbout;



// WEBPACK FOOTER //
// ./src/components/ReadMoreAbout.js